import { useState, useEffect } from "react";
import { get, put, post } from "../api";
import { QueryClient, useQuery, useMutation } from "@tanstack/react-query";

async function getItems() {
  return await get("/item_groups/view");
}

function useShop() {
  const [state, setState] = useState([]);
  const [groups, setGroups] = useState([]);
  const [searchString, setSearchString] = useState("");
  useEffect(
    () =>
      setGroups(
        state.map((group) => ({
          item_group_id: group.item_group_id,
          group_key: group.group_key,
          group_name: group.group_name,
        }))
      ),
    [state]
  );
  const shopQuery = useQuery({
    queryKey: ["shop"],
    queryFn: getItems,
    onSuccess: (data) => setState(data),
  });

  return {
    state,
    searchString,
    setSearchString,
    groups,
  };
}
export default useShop;
